import React from "react";

const CtaSection = () => {
  return (
    <section
      className="cta-2-area mega-hover"
      style={{
        backgroundImage: "url('/img/bg/cta-bg-1-2.jpg')",
      }}
    >
      <div className="container">
        <div className="cta-2-bg-wrapper">
          <div className="col-lg-5 col-md-7 col-sm-9">
            <div className="cta-box1-2">
              <div className="thumb">
                <img
                  src="/img/icon/cta-1-2-shape.png"
                  alt="img"
                />

                <div className="cta-content-title">
                  <div className="title-area mb-10">
                    <span className="box-title">BLACK</span>

                    <h4 className="box-title style1">FRIDAY</h4>

                    <h3 className="sec-title style1">
                      70 <span className="percent">%</span>{" "}
                      <span className="up-to">
                        Up to
                        <br />
                        off
                      </span>
                    </h3>
                  </div>
                </div>

                <a
                  href="/dealership-list"
                  className="th-btn style2"
                >
                  Buy Now{" "}
                  <i className="fas fa-arrow-up-right"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CtaSection;